'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _iBem = require('../../i-bem/i-bem.react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _iBem.declMod)({ view: 'default' }, {
    block: 'select2',
    mods: function mods(_ref) {
        var tone = _ref.tone;

        return _extends({}, this.__base.apply(this, arguments), {
            tone: tone
        });
    },

    // У самого селекта, в отличие от кнопки, нет анимации,
    // поэтому попап сразу рассчитывается правильно.
    attrs: function attrs() {
        return _extends({}, this.__base.apply(this, arguments), {
            ref: this._setAnchor
        });
    }
}, {
    propTypes: {
        tone: _propTypes2.default.string
    },
    defaultProps: {
        tone: 'default',
        size: 'n'
    }
});